document.addEventListener("DOMContentLoaded", function () {
  var $thumbnail = document.querySelector("[id^='social-actusite-migration-thumbnail-']");
  if (!$thumbnail || typeof globalThis.App === "undefined" || !globalThis.App.cable) return;

  var projectId = $thumbnail.id.replace("social-actusite-migration-thumbnail-", "");

  globalThis.App.cable.subscriptions.create(
    {
      channel: "Backoffice::Social::Migration::ActusiteChannel",
      project_id: projectId
    },
    {
      received: function (data) {
        if (data.action === "update_thumbnail") {
          var $current = document.getElementById("social-actusite-migration-thumbnail-" + projectId);
          if ($current) {
            var template = document.createElement("div");
            template.innerHTML = data.html;
            $current.replaceWith(template.firstElementChild);
          }
        }
      }
    }
  );
});
